import {withNaming} from "@bem-react/classname";

export const bemClassNames = withNaming({e: "__", m: "--"});
